import i18n from '@/lang'

export default [
  {
    path: '/device/management',
    name: 'deviceManagement',
    component: () => import('@/pages/DeviceManagement'),
    meta: {
      title: i18n.t('router.main.deviceManagement'),
      requireAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/device.js